import { render, staticRenderFns } from "./monthPlainDetail.vue?vue&type=template&id=9f15f762&scoped=true&"
import script from "./monthPlainDetail.vue?vue&type=script&lang=js&"
export * from "./monthPlainDetail.vue?vue&type=script&lang=js&"
import style0 from "./monthPlainDetail.vue?vue&type=style&index=0&id=9f15f762&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f15f762",
  null
  
)

export default component.exports